"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.czZones = void 0;
var czZones = exports.czZones = [{
  id: 'PRAGUE',
  name: 'Prague',
  country: 'CZ',
  cornerNW: {
    latitude: 50.1774,
    longitude: 14.2244
  },
  cornerSE: {
    latitude: 49.9419,
    longitude: 14.7067
  },
  subZones: [{
    name: 'Praha Staré Město',
    zipcodes: {
      11000: {
        label: '11000'
      }
    }
  }, {
    name: 'Praha Vinohrady',
    zipcodes: {
      12000: {
        label: '12000'
      }
    }
  }, {
    name: 'Praha Žižkov',
    zipcodes: {
      13000: {
        label: '13000'
      }
    }
  }, {
    name: 'Praha Nusle',
    zipcodes: {
      14000: {
        label: '14000'
      }
    }
  }, {
    name: 'Praha Dejvice',
    zipcodes: {
      16000: {
        label: '16000'
      }
    }
  }]
}];